import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { UserEvent } from "@/model/data/userEvents/UserEvent";

export class FetchUserEventsResData extends ApiGenericResponse {
    userEvents: UserEvent[];
    totalEventsCount: number = 0;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.UserEvents) {
            this.userEvents = new Array<UserEvent>();
            obj.UserEvents.forEach((event) => {
                let e = new UserEvent();
                e.parse(event);
                this.userEvents.push(e);
            });
        }
        if (obj.TotalEventsCount != null && obj.TotalEventsCount != undefined) this.totalEventsCount = obj.TotalEventsCount;
    }
}
